import { render, staticRenderFns } from "./column-goods.vue?vue&type=template&id=4c52a653&scoped=true&"
import script from "./column-goods.vue?vue&type=script&lang=js&"
export * from "./column-goods.vue?vue&type=script&lang=js&"
import style0 from "./column-goods.vue?vue&type=style&index=0&id=4c52a653&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c52a653",
  null
  
)

export default component.exports